import { tv } from 'tailwind-variants'

import { h3 } from '@ui-kit/core/typography'

export const accordionListContainer = tv({
  base: 'flex w-full max-w-list flex-col gap-y-2.5',
  variants: {
    bordered: {
      true: 'gap-y-5',
    },
    rowDividerBordered: {
      true: 'gap-y-0 divide-y border-b',
    },
  },
  defaultVariants: {
    bordered: false,
    rowDividerBordered: false,
  },
})

export const accordionItem = tv({
  slots: {
    content: 'hidden overflow-hidden pt-2.5',
    container: 'rounded-lg border border-solid border-transparent px-3 py-3',
    // We need web specific styles to prevent w-full to be applied on mobile
    // Note: w-full adds a negative margin that causes misalignment on React Native
    trigger: h3({
      className: 'group flex flex-row items-center justify-between gap-x-4 web:w-full',
    }),
    triggerActionIcon:
      'flex hidden group-data-[state=open]:rotate-180 web:transition web:duration-200 web:ease-in-out',
    icon: 'flex w-6 flex-shrink-0 flex-col items-start',
    // we need to set max width of text to make the whole
    // item responsive in small screens
    // 48px: xlarge here means:
    // space of 16px between text and arrow + arrow icon of width w-6 (32px)
    triggerTextContainer: `flex max-w-[calc(100%-48px)] shrink grow flex-col justify-center`,
  },
  variants: {
    isExpandable: {
      true: {
        container:
          'cursor-pointer outline-blue-sky hover:opacity-70 active:opacity-70 web:transition',
        triggerActionIcon: 'block',
      },
      false: {
        container: 'cursor-default outline-none',
      },
    },
    hasIcon: {
      true: { content: 'ml-2.5 pl-8' },
    },
    isExpanded: {
      true: {
        triggerActionIcon: 'rotate-180',
        content: 'block',
      },
    },
    rowDividerBordered: {
      true: {
        container: 'rounded-none border-x-0 border-y-0 px-0 py-6',
        content: 'hidden overflow-hidden',
      },
    },
  },
})
